// Pure helpers for the single-click connection-draw model: the user
// clicks to drop each point and double-clicks to finish. The geometry math lives
// here so it can be unit-tested independently of the EditorWrapper component.

type Point = { x: number; y: number }

// Finishing a line on a double-click lands two near-coincident clicks, and a user
// can also click almost in place. Trailing points within this many drawing px of
// the point before them are duplicates and get dropped when the line is finished.
export const FINISH_DEDUP_PX = 3

// Drop trailing points that coincide (within `tol` px) with the point before
// them, walking back toward the start. Only trailing points are trimmed — a short
// segment in the middle of the line is intentional and kept. An empty result
// means every vertex collapsed onto the start, i.e. a degenerate line that the
// caller should discard rather than persist.
export function trimTrailingDuplicateVertices(
  start: Point,
  vertices: Point[],
  tol: number = FINISH_DEDUP_PX,
): Point[] {
  let verts = vertices
  while (verts.length >= 1) {
    const last = verts[verts.length - 1]
    const prev = verts.length >= 2 ? verts[verts.length - 2] : start
    if (Math.hypot(last.x - prev.x, last.y - prev.y) < tol) verts = verts.slice(0, -1)
    else break
  }
  return verts
}
